module.exports = __webpack_public_path__ + "img/bild2.6e12a829.jpeg";